import React from 'react'
import Layout from '../../component/Layout';
import CompatibilityContent from '../../component/CompatibilityContent';
import { useParams } from 'react-router-dom';
import SystemCompatibility from '../../component/SystemCompatibility';
import { t } from 'i18next';

const PageCompatiblityContainer = () => {
	const { id } = useParams();

	return (
		<Layout title={t(`${id}_compatibility`)} description={t("compatibility_desc")}>
			{
				id === 'system' ?
					<SystemCompatibility />
					:
					<CompatibilityContent />
			}
		</Layout>
	)
}

export default PageCompatiblityContainer